/**
 * Shared Utils Package
 */
export const formatDate = (val: any, onlyDate: boolean = false, defaultString: string = '') => {
    if (!val) {
        return defaultString;
    }
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: onlyDate ? undefined : '2-digit',
        minute: onlyDate ? undefined : '2-digit',
        timeZone: 'Europe/Berlin',
        // timeZoneName: 'short'
    };
    return new Date(parseInt(`${val}000`, 10)).toLocaleString('de-DE', options);
};

export const formatDateGerman = (val: any) => {
    const date = new Date(parseInt(`${val}000`, 10)); // Convert timestamp to Date object
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
    const year = date.getFullYear(); // Get full year

    return `${day}.${month}.${year}`; // Return in dd.mm.yyyy format
};

export const formatName = (firstName: string, lastName: string, full: boolean = true) => {
    if (full) {
        return `${firstName || ''} ${lastName || ''}`;
    }
    return `${(firstName || '').charAt(0)}. ${lastName || ''}`;
};

export const formatPaginationText = (
    totalCount: number,
    entity: { singular: string; plural: string },
    paginationText: string = `Seite {currentPage} / {totalPages}`
) => {
    const entityName = totalCount === 1 ? entity.singular : entity.plural;
    return `${paginationText} (${totalCount} ${entityName})`;
};

export const formatNumber = (val: number | string, locale: string = 'de-DE') => {
    if (val === null || val === undefined || val === '') {
        return '';
    }
    const num = typeof val === 'string' ? parseFloat(val) : val;
    if (isNaN(num)) {
        return '';
    }
    return num.toLocaleString(locale);
};

export const setPrimaryColor = (color: string) => {
    if (!color || !color.startsWith('#')) {
        return;
    }
    document.documentElement.style.setProperty('--primary-color', color);
    document.documentElement.style.setProperty('--primary-color-hover', getHoverColor(color, 10));
    document.documentElement.style.setProperty('--primary-color-contrast', color);
};

export const getHoverColor = (hex: string, amount = 10) => {
    // Normalize input
    hex = hex.replace(/^#/, '');
    if (hex.length !== 6) throw new Error('Ungültige HEX-Farbe');

    // Parse RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Darken each channel
    r = Math.max(0, r - amount);
    g = Math.max(0, g - amount);
    b = Math.max(0, b - amount);

    // Convert back to HEX and return
    return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
};

export const isEmbedded = () => {
    let isInIframe = false;

    try {
        isInIframe = window.self !== window.top;
    } catch (e) {
        isInIframe = true;
    }

    return isInIframe;
};

export const createFingerprint = () => {
    const navigatorInfo = [
        navigator.userAgent,
        navigator.language,
        window.screen.height,
        window.screen.width,
        window.screen.colorDepth,
        new Date().getTimezoneOffset(),
    ].join('|');

    let hash = 0;
    for (let i = 0; i < navigatorInfo.length; i++) {
        hash = (hash << 5) - hash + navigatorInfo.charCodeAt(i);
        hash |= 0; // in 32-bit int umwandeln
    }
    return `fp_${Math.abs(hash)}`;
};

export const generateDeviceId = () => {
    const randomPart = Math.random().toString(36).substring(2, 15);
    return `device_${randomPart}`;
};

export const formatStringToDate = (dateString: string | null) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day); // Monate sind 0-basiert
};
